(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hi", [], factory);
	else if(typeof exports === 'object')
		exports["hi"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["hi"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 